import NihaoBridgePage from "../components/pages/nihao-bridge/NihaoBridgePage";

export default function NihaoBridgeVnPage() {
  return <NihaoBridgePage locale="vn" />;
}
